export default {
  pageTitle: 'Beranda',
  metaDescription: 'PT TEF adalah fabrikator pressure vessel, heat exchanger, dan peralatan industri di Indonesia menggunakan material khusus untuk industri Migas, Petrokimia, dan Pembangkit Listrik.',
  videoNotSupported: 'Browser Anda tidak mendukung tag video.',
  counters: {
    project: 'PROYEK',
    countriesExport: 'NEGARA EKSPOR',
    typeOfMaterials: 'JENIS MATERIAL',
    customers: 'PELANGGAN',
  },
  oneStopSolutions: {
    title: 'Solusi Satu Atap',
    description:
      'TEF sangat berpengalaman dalam fabrikasi produk menggunakan stainless steel, paduan berbasis nikel, titanium, dan material eksotis lainnya. Keahlian kami memastikan daya tahan, presisi, dan kepatuhan terhadap standar internasional.',
    fabrication: {
      title: 'Solusi Fabrikasi',
      description: 'Kami memproduksi berbagai peralatan industri, termasuk: ......',
      readMore: 'Baca Selengkapnya',
    },
    reconditioning: {
      title: 'Rekondisi & Layanan Teknis',
      description: 'Selain fabrikasi baru, kami juga menyediakan layanan perawatan dan rekondisi....',
      readMore: 'Baca Selengkapnya',
    },
  },
  pioneers: {
    title: 'Kami adalah pionir fabrikasi <br> dengan material khusus',
    description:
      'Dengan komitmen kuat terhadap keunggulan teknik, keahlian konsultasi, teknik pengelasan canggih, dan penanganan material khusus, TEF terus berinovasi untuk memenuhi tuntutan industri yang terus berkembang.',
  },
  gallery: {
    title: 'Galeri Karya Kami',
    tabs: {
      machine: 'Mesin',
      area: 'Area',
      worker: 'Pekerja',
    },
  },
  news: {
    title: 'Berita dan Blog Terbaru',
    subtitle: 'Ikuti perkembangan terbaru dan wawasan dari PT TEF',
    readMore: 'BACA SELENGKAPNYA',
    moreButton: 'Berita & Blog Lainnya',
  },
  clients: {
    title:
      'Kami bangga memberikan produk berkualitas yang memuaskan pelanggan kami, dengan <br> kesuksesan yang didukung oleh kepercayaan pelanggan, karyawan, dan komunitas.',
  },
  moto: {
    title: 'START',
    subtitle: 'sebagai semboyan TOKKI Group',
    skillUp: { word: 'Skill-up', desc: 'Kami akan terus berupaya meningkatkan level teknologi individu.' },
    timely: { word: 'Timely', desc: 'Kami akan berusaha menyediakan dokumen, material, dan produk yang diperlukan secara tepat waktu.' },
    active: { word: 'Active', desc: 'Kami akan berhenti menunggu instruksi dan bersikap proaktif dalam bekerja.' },
    responsibility: { word: 'Responsibility', desc: 'Kami akan bertanggung jawab atas pekerjaan kami.' },
    try: { word: 'Try', desc: 'Kami tidak puas dengan keadaan saat ini dan akan mencoba hal-hal baru. <br> Kami akan bertindak lebih dulu dan tidak mencari alasan mengapa kami tidak bisa melakukan sesuatu.' },
  },
};
